import { defineMessages } from 'react-intl';

export default defineMessages({
  seoTitle: {
    id: 'cc4.seo.upload-identification.title',
    defaultMessage: '',
  },
  seoDescription: {
    id: 'cc4.seo.upload-identification.description',
    defaultMessage: '',
  },
  uploadHeader: {
    id: 'cc4.form.direct-feedback-upload.header',
    defaultMessage:
      'Upload {documentType, select, identification {Passport or ID card} booking_docs {Boarding pass or E-ticket} booking_confirmation {Booking Confirmation} payment_receipt {Payment Receipt} delay_confirmation {Delay Confirmation}  birth_certificate {Birth Certificate}}{passengerName, select, null {} other {<dark> for {passengerName}</dark>}}',
  },
  isUploading: {
    id: 'cc4.form.upload-identification.uploading-message',
    defaultMessage: 'Uploading...',
  },
  isProcessing: {
    id: 'cc4.form.upload-identification.processing-message',
    defaultMessage: 'Processing...',
  },
  description: {
    id: 'cc4.form.direct-feedback-upload.description',
    defaultMessage:
      '{documentType, select, identification {Passport or ID card <strong>(front and back)</strong>} booking_docs {Boarding pass or E-ticket} booking_confirmation {Booking Confirmation} payment_receipt {Payment Receipt} delay_confirmation {Delay Confirmation} birth_certificate {Birth Certificate}} of all passengers is legally required by the airline. If you don’t have the documents for your fellow passengers, share the requirements or do it later.',
  },
  uploadedFilesText: {
    id: 'cc4.form.upload-identification.uploaded-files',
    defaultMessage: 'Uploaded files',
  },
  duplicateFileNotification: {
    id: 'cc4.form.upload-identification.duplicate-file-notification',
    defaultMessage: 'Please note: duplicated document uploaded.',
  },
  fileProcessingFailed: {
    id: 'cc4.form.upload-identification.file-processing-failed',
    defaultMessage: 'File processing failed.',
  },
  complete: {
    id: 'cc4.form.upload-identification.requirement-status-complete',
    defaultMessage: 'Uploaded',
  },
  pending: {
    id: 'cc4.form.upload-identification.requirement-status-pending',
    defaultMessage: 'Missing',
  },
  failed: {
    id: 'cc4.form.upload-identification.requirement-status-failed',
    defaultMessage: 'Invalid',
  },
  waiting_for_approval: {
    id: 'cc4.form.upload-identification.requirement-waiting-for-approval',
    defaultMessage: 'Uploaded',
  },
  asideText: {
    id: 'cc4.form.upload-identification.aside-text',
    defaultMessage:
      'Speed up by providing necessary documents. Up to <strong>80% faster</strong> claim processing!',
  },
  backButtonText: {
    id: 'cc4.form.upload-identification.back-button-text',
    defaultMessage: 'Back',
  },
  laterButtonText: {
    id: 'cc4.form.upload-identification.later-text',
    defaultMessage: "I'll do it later",
    description: 'Text on button to upload identification later',
  },
  submitButtonText: {
    id: 'cc4.form.upload-identification.submit-button-text',
    defaultMessage: 'Continue',
  },
  saveButtonText: {
    id: 'cc4.form.direct-feedback-upload.save-button-text',
    defaultMessage: 'Save and close',
  },
  labelTypeOfDocument: {
    id: 'cc4.form.direct-feedback-upload.label-type-of-document',
    defaultMessage: 'Type of document',
  },
  uploadAdditionalDocumentTitle: {
    id: 'cc4.form.upload-other-document.upload-additional-document-title',
    defaultMessage: 'Upload additional document',
  },
  placeholderTypeOfDocument: {
    id: 'cc4.form.upload-other-document.placeholder-type-of-document',
    defaultMessage: 'Select an option',
  },
  documentTypeExtraCosts: {
    id: 'cc4.form.upload-other-document.document-type-extra-costs',
    defaultMessage: 'Extra costs',
  },
  documentTypeAirlineReaction: {
    id: 'cc4.form.upload-other-document.document-type-airline-reaction',
    defaultMessage: 'Airline reaction',
  },
  documentTypeOther: {
    id: 'cc4.form.upload-other-document.document-type-other',
    defaultMessage: 'Other',
  },
  documentTypeReleveDidentiteBancaire: {
    id:
      'cc4.form.upload-other-document.document-type-releve-didentite-bancaire',
    defaultMessage: 'Releve d’identite bancaire',
  },
  documentTypeBirthCertificate: {
    id: 'cc4.form.upload-other-document.document-type-birth-certificate',
    defaultMessage: 'Family book record / birth certificate',
  },
  documentTypeAbandonedLetter: {
    id: 'cc4.form.upload-other-document.document-type-abandoned-letter',
    defaultMessage: 'Abandoned letter',
  },
  mailCatcherContainerTitle: {
    id: 'cc4.form.direct-feedback-upload.mail-catcher-container.title',
    defaultMessage: 'How can I forward my Booking Confirmation?',
  },
  mailCatcherContainerBookingConfirmationDescription: {
    id:
      'cc4.form.direct-feedback-upload.mail-catcher-container.booking-confirmation.description',
    defaultMessage:
      'Alternatively to uploading the document, you can also forward it to us via email following these steps:',
  },
  mailCatcherContainerMailbox: {
    id:
      'cc4.form.direct-feedback-upload.mail-catcher-container.booking-confirmation.mailbox',
    defaultMessage:
      '1. <strong>Mailbox</strong>. Go to the mailbox used to book your flight.',
  },
  mailCatcherContainerMailSearch: {
    id:
      'cc4.form.direct-feedback-upload.mail-catcher-container.booking-confirmation.search',
    defaultMessage:
      '2. <strong>Search</strong>. Search for emails related to your flight typing the name of the airline.',
  },
  mailCatcherContainerMailForward: {
    id:
      'cc4.form.direct-feedback-upload.mail-catcher-container.booking-confirmation.forward',
    defaultMessage:
      '3. <strong>Forward</strong>. Forward the mails to our special upload email address bellow.',
  },
  howDoesABoardingPassLook: {
    id: 'cc4.form.direct-feedback-upload.how-does-a-boarding-pass-look',
    defaultMessage: 'How does a boarding pass look?',
  },
  paperBoardingPass: {
    id: 'cc4.form.direct-feedback-upload.paper-boarding-pass',
    defaultMessage:
      "If you check in at the airport, you'll receive a paper boarding pass.",
  },
  electronicBoardingPass: {
    id: 'cc4.form.direct-feedback-upload.electronic-boarding-pass',
    defaultMessage:
      "If you check in online, you'll receive an electronic boarding pass.",
  },
  passengerUpdated: {
    id: 'cc4.form.direct-feedback-upload.passenger-updated',
    defaultMessage: 'Passenger has been updated.',
  },
  failedPassengerUpdated: {
    id: 'cc4.form.direct-feedback-upload.passenger-updated-failed',
    defaultMessage: 'Failed to update passenger.',
  },
});
